// extracted by mini-css-extract-plugin
export var disabled = "_e-a";
export var hierarchyLinkGray = "_e-4";
export var hierarchyLinkUnderline = "_e-3";
export var hierarchyPrimary = "_e-0";
export var hierarchySecondary = "_e-1";
export var hierarchyTertiary = "_e-2";
export var pressed = "_e-6";
export var themeAction = "_e-5";
export var themeDestructive = "_e-8";
export var themeNormal = "_e-7";
export var themeSuccess = "_e-9";